export function answer(state) {
	return state.answer;
}

export function is_required(state) {
	return state.is_required;
}

export function is_displayed(state) {
	return state.is_displayed;
}

export function error_message(state) {
	return state.error_message;
}

export function app_types(state) {
	return state.app_types;
}

export function multi_field_parent(state) {
	return state.multi_field_parent;
}

export function answer_externally_updated(state) {
	return state.answer_externally_updated === true;
}
